<template>
  <div class="flex flex-col text-center">
    <div>Storefront Links</div>

    <ul class="flex">
      <li v-for="(store, index) in stores" :key="index">
        <a :href="encode(store.url)">
          <icon-fgt :name="store.logo" class="w-10 h-10 inline-block mx-1" />
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "StoreFrontLinks",
  methods: {
    encode(url) {
      let email = this.$store.state.user.cognitoInfo.email;
      var enc = btoa(email).split("").reverse().join("");
      return `${url}/?_fgt_agent=${enc}`;
    },
  },
  data() {
    return {
      stores: [
        {
          logo: "fgt-logo",
          url: process.env.VUE_APP_STOREFRONT_URL_FGT,
        },
        {
          logo: "bb-logo",
          url: process.env.VUE_APP_STOREFRONT_URL_BB,
        },
        {
          logo: "pt",
          url: process.env.VUE_APP_STOREFRONT_URL_PT,
        },
      ],
    };
  },
};
</script>
